import {LABELS} from '../constants/labels'

export const LABEL_NAME_MAX_LENGTH = 50

export function validateLabelName(name: string) {
  const trimmedName = name.trim()

  if (!trimmedName) return LABELS.nameRequired
  return trimmedName.length > LABEL_NAME_MAX_LENGTH ? LABELS.nameTooLong : null
}
